import { addCyPrefixToIDs } from 'moet-test-utils/cypress/utils';

const cyPrefix = 'containers_documents_container';

const ids = addCyPrefixToIDs(cyPrefix, {
  BTN_SUBMIT: 'BTN_SUBMIT',
  BUTTON_BROWSE_FILES: 'BUTTON_BROWSE_FILES',
  ELEMENT_DOCUMENT_VIEWER: 'ELEMENT_DOCUMENT_VIEWER',
});

/**
 * We are exporting the IDS this way to help IDEs' code completion
 */
export const CY_DOCUMENTS_CONTAINER_IDS = ids;
